import { create } from 'zustand';

interface OrderDropdownStore {
  /** Whether the orders dropdown in the app header is open */
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  resetStore: () => void;
}

const initialState = {
  isOpen: false,
};

/**
 * Controls the open/closed state of the orders DropdownPopover in the app header.
 *
 * The orders-variant DropdownPopover (buttonHref="orders") reads `isOpen` from
 * this store. When true the panel is forced open via the Headless UI `static`
 * prop. All close paths (click-outside, child `onCloseDropdown`) reset `isOpen`
 * back to false.
 *
 * This allows any component in the app to programmatically open the orders
 * dropdown without navigating or manipulating URL query params.
 *
 * @example
 * ```tsx
 * const setIsOpen = useOrderDropdownStore((s) => s.setIsOpen);
 *
 * // Open the orders dropdown
 * setIsOpen(true);
 *
 * // Close it
 * setIsOpen(false);
 * ```
 */
export const useOrderDropdownStore = create<OrderDropdownStore>((set) => ({
  ...initialState,
  setIsOpen: (open: boolean) => set({ isOpen: open }),
  resetStore: () => set(initialState),
}));
